import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import {
  KodingDetail,
  KodingListParams,
  KodingListResponse,
  KodingLogRow,
  KodingSimpanPayload
} from "@/types/kodingIcd";

async function getList(params: KodingListParams): Promise<KodingListResponse> {
  const resp = await http
    .getDataParam("/koding-icd", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return resp.data;
}

async function getDetail(registerId: string | number): Promise<KodingDetail> {
  const resp = await http
    .getData(`/register/${registerId}/koding-icd`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return resp.data.data;
}

async function simpan(registerId: string | number, data: KodingSimpanPayload) {
  const resp = await http
    .postData(`/register/${registerId}/koding-icd`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return resp.data;
}

async function getLog(registerId: string | number): Promise<KodingLogRow[]> {
  const resp = await http
    .getData(`/register/${registerId}/koding-icd/log`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return resp.data.data;
}

export default { getList, getDetail, getLog, simpan };
